export default "__VITE_ASSET__BYz9kB5X__"